import React, { useRef } from 'react';
import { Button } from './ui/Button';
import { Check, Lock } from 'lucide-react';
import { motion, useInView } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="pricing" className="py-24 px-4 sm:px-6 bg-[#F5F0EB]" data-id="element-1">
      <div className="max-w-4xl mx-auto" ref={ref} data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        scale: 1,
        y: 0
      } : {
        opacity: 0,
        scale: 0.95,
        y: 40
      }} transition={{
        duration: 0.7
      }} className="bg-[#FAF8F6] rounded-3xl shadow-xl border border-neutral-200 overflow-hidden" data-id="element-3">
          <div className="grid md:grid-cols-2" data-id="element-4">
            {/* Left Side: Value */}
            <div className="p-8 md:p-12 bg-neutral-900 text-white flex flex-col justify-between" data-id="element-5">
              <div data-id="element-6">
                <h3 className="text-3xl font-bold font-serif mb-6" data-id="element-7">
                  What's inside the kit:
                </h3>
                <ul className="space-y-4 mb-8" data-id="element-8">
                  {['The 14-Day Step-by-Step Roadmap', "15+ 'Cut & Paste' Scripts for tough conversations", 'Housing Red Flag Scanner', 'Contract Breaker Checklist', "The 'Proof Library' Organization System", "Emergency 'Stall for Time' Tactics"].map((item, i) => <motion.li key={i} initial={{
                  opacity: 0,
                  x: -20
                }} animate={isInView ? {
                  opacity: 1,
                  x: 0
                } : {
                  opacity: 0,
                  x: -20
                }} transition={{
                  duration: 0.5,
                  delay: i * 0.1 + 0.4
                }} className="flex items-start gap-3" data-id="element-9">
                      <Check className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-10" />
                      <span className="text-neutral-200" data-id="element-11">{item}</span>
                    </motion.li>)}
                </ul>
              </div>
              <div className="pt-8 border-t border-neutral-800" data-id="element-12">
                <p className="text-neutral-400 text-sm italic" data-id="element-13">
                  "I wish I had this before I lost my deposit."
                </p>
              </div>
            </div>

            {/* Right Side: Price & Action */}
            <div className="p-8 md:p-12 flex flex-col justify-center items-center text-center bg-[#FAF8F6]" data-id="element-14">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-700 text-sm font-bold mb-4 border border-red-200" data-id="element-15">
                70% OFF
              </div>
              <div className="mb-6" data-id="element-16">
                <span className="text-neutral-500 text-lg line-through decoration-red-500 decoration-2 mr-3" data-id="element-17">
                  $21.30
                </span>
                <span className="text-5xl font-bold text-neutral-900" data-id="element-18">
                  $6.39
                </span>
              </div>

              <p className="text-neutral-600 mb-8" data-id="element-19">
                One-time payment. Lifetime access. <br data-id="element-20" />
                Less than the cost of one "foreigner tax" mistake.
              </p>

              <Button size="lg" className="w-full text-lg py-6 mb-4 shadow-lg shadow-neutral-900/10" onClick={() => {
              trackAddToCart();
              window.open('https://www.versastorex.com/cart/41995679793232:1', '_blank');
            }} data-id="element-21">
                Get Instant Access
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-neutral-400" data-id="element-22">
                <Lock className="h-3 w-3" data-id="element-23" />
                Secure payment via Stripe
              </div>

              <div className="mt-8 p-4 bg-amber-50 rounded-lg border border-amber-100 w-full" data-id="element-24">
                <p className="text-amber-800 text-sm font-medium" data-id="element-25">
                  100% Money-Back Guarantee
                </p>
                <p className="text-amber-700 text-xs mt-1" data-id="element-26">
                  If it doesn't save you stress in the first week, we'll refund
                  you. No questions asked.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}